import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
import type { FilterDropdownSize, FilterDropdownVariant } from './types'

@safeCustomElement('mdc-filter-dropdown')
export class MdcFilterDropdown extends LitElement {
  @property({ type: String }) size: FilterDropdownSize = 'md'
  @property({ type: String }) variant: FilterDropdownVariant = 'base'
  @property({ type: Boolean }) hidden = false
  @property({ type: Boolean, attribute: 'with-gap' }) withGap = false
  @property({ type: Boolean, attribute: 'without-border-radius-bottom' })
  withoutBorderRadiusBottom = false

  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-filter-dropdown {
			width: var(--mdc-filter-dropdown-width, auto);
			height: var(--mdc-filter-dropdown-height, auto);
			border: 1px solid var(--color-functional-gray-200, #e5e5e5);
			border-radius: 0.5rem;
			padding: var(--mdc-filter-dropdown-padding, 0.75rem);
			background-color: var(--color-functional-gray-white, #ffffff);
			box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12);
			box-sizing: border-box;
		}

		.mdc-filter-dropdown--without-border-radius-bottom {
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
		}

		.mdc-filter-dropdown--md {
			--mdc-filter-dropdown-padding: 1.25rem;
		}

		.mdc-filter-dropdown--lg {
			--mdc-filter-dropdown-padding: 1.5rem;
		}

		.mdc-filter-dropdown--with-gap {
			display: flex;
			flex-direction: column;
			gap: 1.25rem;
		}

		.mdc-filter-dropdown--hidden {
			display: none;
		}
	`

  render() {
    const classes = [
      'mdc-filter-dropdown',
      `mdc-filter-dropdown--${this.size}`,
      this.variant === 'category' ? 'mdc-filter-dropdown--category' : '',
      this.variant === 'search' ? 'mdc-filter-dropdown--search' : '',
      this.hidden ? 'mdc-filter-dropdown--hidden' : '',
      this.withGap ? 'mdc-filter-dropdown--with-gap' : '',
      this.withoutBorderRadiusBottom ? 'mdc-filter-dropdown--without-border-radius-bottom' : '',
    ]
      .filter(Boolean)
      .join(' ')

    return html`<div class=${classes}><slot></slot></div>`
  }
}
